import { NAME } from './constants';

export const SET_PURCHASE_POPUP_VISIBLE = `${NAME}.SET_PURCHASE_POPUP_VISIBLE`;
export const SET_QUANTITY_OF_LICENSES = `${NAME}.SET_QUANTITY_OF_LICENSES`;
export const SET_QUANTITY_OF_LICENSES_ERROR = `${NAME}.SET_QUANTITY_OF_LICENSES_ERROR`;
export const SET_PRICE = `${NAME}.SET_PRICE`;
export const SET_GET_PRICE_LOADING = `${NAME}.SET_GET_PRICE_LOADING`;
export const SET_PURCHASE_LOADING = `${NAME}.SET_PURCHASE_LOADING`;
